module.exports = __webpack_public_path__ + "static/media/global_digital_health_company_of_the_year.58cf681d.jpeg";